<template>
    <OrderReviewRow
        :bold="!hasDeposit"
        :label="totalLabel"
        :value="$n(totalDue || 0, 'currency')"
    />

    <OrderReviewRow
        v-if="!isRecurring && hasDeposit"
        bold
        :label="depositLabel"
        :value="$n(depositAmountDue, 'currency')"
    />
</template>

<script>
import OrderReviewRow from '../order/OrderReviewRow.vue';

const DEPOSIT_TYPES = {
    percent: 'percent',
    dollar: 'dollar',
};

export default {
    components: {
        OrderReviewRow,
    },

    props: {
        isRecurring: Boolean,
        totalDue: {
            type: Number,
            default: 0,
        },
        invoice: {
            type: Object,
            default: () => {
                return {
                    totalPaid: 0,
                    total: 0,
                    payPlan: {
                        amountDue: 0,
                        percentDue: 0,
                    },
                };
            },
        },
    },

    computed: {
        hasPercentDue() {
            return Boolean(this.invoice && this.invoice.payPlan && this.invoice.payPlan.percentDue);
        },

        hasAmountDue() {
            return Boolean(this.invoice && this.invoice.payPlan && this.invoice.payPlan.amountDue);
        },

        depositDollarAmount() {
            if (this.invoice.totalPaid > 0 && this.invoice.payPlan) {
                return this.invoice.payPlan.amountDue - this.invoice.totalPaid;
            }

            if (this.hasPercentDue) {
                return this.totalDue * this.invoice.payPlan.percentDue / 100;
            }

            return this.invoice && this.invoice.payPlan && this.invoice.payPlan.amountDue;
        },

        depositAmountDue() {
            return this.depositDollarAmount > 0 ? this.depositDollarAmount : 0;
        },

        hasDeposit() {
            return Boolean((this.hasAmountDue || this.hasPercentDue) && this.depositAmountDue);
        },

        depositLabel() {
            return this.hasDeposit ? this.$t('InvoiceDeposit.depositDue') : '';
        },

        totalLabel() {
            return this.hasDeposit ? this.$t('InvoiceDeposit.total') : this.$t('InvoiceDeposit.totalDue');
        },

        maxAmount() {
            if (this.localDeposit.type === DEPOSIT_TYPES.percent) {
                return 100;
            }

            return this.totalDue;
        },
    },
};
</script>
